var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-confirm",
            centered: "",
            "body-class": "p-0 br-8",
            "hide-footer": "",
            "hide-header": "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "dialog-class": "base-modal",
          },
        },
        [
          _c("div", { staticClass: "title" }, [
            _c("div", [_vm._v(_vm._s(_vm.$t("modal.nophone.title")))]),
          ]),
          _c(
            "div",
            { staticClass: "modal-content" },
            [
              _c("div", [_vm._v(_vm._s(_vm.$t("modal.nophone.content")))]),
              _vm.modal_second
                ? _c("b-form-group", { staticClass: "mb-2 mt-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center",
                      },
                      [
                        _c("vue-tel-input", {
                          staticStyle: {
                            "box-shadow": "none",
                            width: "100%",
                            "font-size": "16px",
                            height: "37px",
                          },
                          attrs: {
                            placeholder: _vm.$t("mypage.userinfo.phoneerr"),
                          },
                          on: { input: _vm.handleInput },
                          model: {
                            value: _vm.new_phone,
                            callback: function ($$v) {
                              _vm.new_phone = $$v
                            },
                            expression: "new_phone",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.phone_send_auth
                      ? _c(
                          "div",
                          {
                            staticClass: "font-s14 text-danger text-left mt-1",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.phone_send_auth) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              !_vm.openAuthForm
                ? _c(
                    "div",
                    [
                      _c(
                        "VueRecaptcha",
                        _vm._b(
                          {},
                          "VueRecaptcha",
                          {
                            verify: _vm.onCaptchaVerified,
                            location: "nophone",
                          },
                          false
                        )
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.openAuthForm
                ? _c(
                    "b-form-group",
                    { staticClass: "mb-2 mt-3" },
                    [
                      _c(
                        "b-input-group",
                        {
                          staticClass: "auth_input_group",
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "auth_timer_time" },
                                      [_vm._v(_vm._s(_vm.auth_timer_time))]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2935813731
                          ),
                        },
                        [
                          _c("b-form-input", {
                            staticStyle: {
                              "font-size": "16px",
                              height: "37px",
                            },
                            attrs: {
                              size: "sm",
                              placeholder: _vm.$t("modal.nophone.placeholder"),
                            },
                            model: {
                              value: _vm.phone_auth_num,
                              callback: function ($$v) {
                                _vm.phone_auth_num = $$v
                              },
                              expression: "phone_auth_num",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "btn-wrapper cancel-on" }, [
            _c(
              "div",
              {
                staticClass: "modal-btn cancel",
                on: { click: _vm.authClickCancel },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("modal.cancel")) + "\n      "
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "modal-btn confirm",
                on: { click: _vm.authClickConfirm },
              },
              [_vm._v(_vm._s(_vm.authModalConfirm))]
            ),
          ]),
        ]
      ),
      _c(
        "BaseModal",
        {
          attrs: {
            id: "authModal",
            "cancel-btn": _vm.cancelBtn,
            "no-content": _vm.noContent,
            "no-close": _vm.noClose,
          },
          on: { clickConfirm: _vm.clickConfirm, clickCancel: _vm.clickCancel },
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.modalTitle) } }),
          ]),
          _c("template", { slot: "content" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.modalContent) } }),
          ]),
          _c("template", { slot: "cancel" }, [
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.$t(_vm.modalCancel)) },
            }),
          ]),
          _c("template", { slot: "confirm" }, [
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.$t(_vm.modalConfirm)) },
            }),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }